function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E66A6A",
  d: "M14.828 2.711l6.46 6.46a4 4 0 0 1 0 5.657l-6.46 6.46a4 4 0 0 1-5.656 0l-6.46-6.46a4 4 0 0 1 0-5.656l6.46-6.46a4 4 0 0 1 5.656 0zm2.968 7.728a5.98 5.98 0 0 0-7.34-4.23 6.017 6.017 0 0 0-4.252 7.352 5.98 5.98 0 0 0 7.34 4.23 6.017 6.017 0 0 0 4.252-7.352zm-2.67-2.366a4.903 4.903 0 0 1 1.618 2.385l-4.142 4.626c-.501.591-1.389.67-1.983.176a1.383 1.383 0 0 1-.5-1.104l-1.407 1.571a4.9 4.9 0 0 1-1.53-2.484l3.81-4.254c.501-.592 1.389-.67 1.983-.177.34.284.51.694.5 1.105z",
  mask: "url(#b)"
}));

var SvgTrialWallet = function SvgTrialWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrialWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trial_wallet.530d568e.svg";
export { ForwardRef as ReactComponent };